import * as React from 'react';
import cn from 'classnames';

import './WithBorder.modules.scss';

type Props = React.PropsWithChildren<{
  focus?: boolean;
  error?: boolean;
  disabled?: boolean;
  className?: string;
  borderRadius?: number | 'circle';
}>;

const WithBorder = React.forwardRef<HTMLDivElement, Props>(
  ({ focus, error, children, className, borderRadius = 8, disabled }, ref) => {
    return (
      <div
        styleName={cn(
          'container',
          focus && 'container_focus',
          error && 'container_error',
          disabled && 'container_disabled'
        )}
        className={className}
        style={{
          borderRadius:
            typeof borderRadius !== 'number' && borderRadius === 'circle'
              ? '50%'
              : borderRadius
        }}
        ref={ref}
      >
        {children}
      </div>
    );
  }
);

export default WithBorder;
